var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle24, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 88,
    viewBox: "0 0 178 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8008,
    y: 12.7539,
    width: 5.40549,
    height: 1.53181,
    transform: "rotate(-112 57.8008 12.7539)",
    fill: "#DCBCFA",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.531,
    y: 65.8838,
    width: 6.7855,
    height: 1.53181,
    transform: "rotate(124 138.531 65.8838)",
    fill: "#4BC8EF",
    fillOpacity: 0.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.981,
    y: 5.85352,
    width: 1.95547,
    height: 0.841804,
    transform: "rotate(-71 141.981 5.85352)",
    fill: "#9DED1A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.331,
    y: 70.7139,
    width: 6.09549,
    height: 0.841804,
    transform: "rotate(-51 152.331 70.7139)",
    fill: "#9DED1A",
    fillOpacity: 0.45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7705,
    y: 43.8037,
    width: 4.71548,
    height: 1.53181,
    transform: "rotate(-143 66.7705 43.8037)",
    fill: "#4BC8EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.041,
    y: 16.2041,
    width: 6.78549,
    height: 0.841804,
    transform: "rotate(-96 55.041 16.2041)",
    fill: "#FFED36",
    fillOpacity: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9707,
    y: 66.5742,
    width: 4.02548,
    height: 0.841804,
    transform: "rotate(-123 52.9707 66.5742)",
    fill: "#FF21FB",
    fillOpacity: 0.75
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0205,
    y: 50.0137,
    width: 3.33548,
    height: 1.53181,
    transform: "rotate(89 15.0205 50.0137)",
    fill: "#FF21FB",
    fillOpacity: 0.35
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 76.4307,
    y: 70.7139,
    width: 4.02548,
    height: 1.53181,
    transform: "rotate(75 76.4307 70.7139)",
    fill: "#F62584",
    fillOpacity: 0.85
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 166.821,
    y: 56.2236,
    width: 2.64547,
    height: 0.841804,
    transform: "rotate(52 166.821 56.2236)",
    fill: "#C9FCBE",
    fillOpacity: 0.65
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1406,
    y: 44.4941,
    width: 4.71548,
    height: 0.841804,
    transform: "rotate(139 48.1406 44.4941)",
    fill: "#4BC8EF",
    fillOpacity: 0.85
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3809,
    y: 64.5039,
    width: 1.26547,
    height: 1.53181,
    transform: "rotate(-119 45.3809 64.5039)",
    fill: "#9AF5FC",
    fillOpacity: 0.35
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1309,
    y: 51.3936,
    width: 4.71548,
    height: 1.53181,
    transform: "rotate(3 28.1309 51.3936)",
    fill: "#DCBCFA",
    fillOpacity: 0.75
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6.74023,
    y: 51.3936,
    width: 4.02548,
    height: 1.53181,
    transform: "rotate(-151 6.74023 51.3936)",
    fill: "#F62584",
    fillOpacity: 0.85
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8906,
    y: 22.4141,
    width: 4.71548,
    height: 1.53181,
    transform: "rotate(80 30.8906 22.4141)",
    fill: "#755FFE",
    fillOpacity: 0.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 117.141,
    y: 13.4434,
    width: 1.95547,
    height: 0.841804,
    transform: "rotate(-108 117.141 13.4434)",
    fill: "#03A3F5",
    fillOpacity: 0.45
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2305,
    y: 24.4834,
    width: 6.78549,
    height: 1.53181,
    transform: "rotate(125 21.2305 24.4834)",
    fill: "#FFED36",
    fillOpacity: 0.9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 135.771,
    y: 54.8438,
    width: 5.40549,
    height: 0.841804,
    transform: "rotate(166 135.771 54.8438)",
    fill: "#03A3F5",
    fillOpacity: 0.65
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 58.9844,
    width: 1.26547,
    height: 1.53181,
    transform: "rotate(27 102.65 58.9844)",
    fill: "#4BC8EF",
    fillOpacity: 0.35
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6504,
    y: 10.6836,
    width: 3.33548,
    height: 0.841804,
    transform: "rotate(80 33.6504 10.6836)",
    fill: "#755FFE",
    fillOpacity: 0.65
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8799,
    y: 74.8535,
    width: 6.78549,
    height: 0.841804,
    transform: "rotate(128 10.8799 74.8535)",
    fill: "#FF21FB",
    fillOpacity: 0.9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 117.141,
    y: 78.9941,
    width: 1.95547,
    height: 0.841804,
    transform: "rotate(-53 117.141 78.9941)",
    fill: "#9DED1A",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.32723,
    cy: 73.5811,
    r: 0.796954,
    fill: "#FFED36"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.6023,
    cy: 61.5057,
    r: 0.451952,
    fill: "#480CA7",
    fillOpacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.26207,
    cy: 35.2855,
    r: 1.14196,
    fill: "#DCBCFA",
    fillOpacity: 0.65
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.368,
    cy: 68.7511,
    r: 0.796954,
    fill: "#F62584",
    fillOpacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4525,
    cy: 75.9955,
    r: 1.14196,
    fill: "#FF21FB",
    fillOpacity: 0.75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9129,
    cy: 46.326,
    r: 0.451952,
    fill: "#F54721",
    fillOpacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.748,
    cy: 31.4909,
    r: 1.48696,
    fill: "#FFED36",
    fillOpacity: 0.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.0675,
    cy: 4.58016,
    r: 0.796954,
    fill: "#9AF5FC",
    fillOpacity: 0.75
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0079,
    cy: 19.7608,
    r: 0.796954,
    fill: "#FC9E1C",
    fillOpacity: 0.75
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.168,
    cy: 50.1212,
    r: 0.796954,
    fill: "#FFED36",
    fillOpacity: 0.45
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.7527,
    cy: 60.1258,
    r: 0.451952,
    fill: "#9DED1A",
    fillOpacity: 0.45
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.538,
    cy: 75.651,
    r: 1.48696,
    fill: "#480CA7",
    fillOpacity: 0.35
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.738,
    cy: 44.6007,
    r: 0.796954,
    fill: "#FFED36",
    fillOpacity: 0.6
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.588,
    cy: 34.2511,
    r: 0.796954,
    fill: "#03A3F5",
    fillOpacity: 0.75
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.7728,
    cy: 83.5863,
    r: 1.14196,
    fill: "#F54721",
    fillOpacity: 0.85
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4125,
    cy: 45.6361,
    r: 1.14196,
    fill: "#4BC8EF",
    fillOpacity: 0.85
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6671,
    cy: 66.6807,
    r: 0.796954,
    fill: "#FC9E1C",
    fillOpacity: 0.45
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.503,
    cy: 44.2552,
    r: 1.14196,
    fill: "#9DED1A",
    fillOpacity: 0.75
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6527,
    cy: 11.8256,
    r: 1.14196,
    fill: "#755FFE",
    fillOpacity: 0.75
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.553,
    cy: 81.5164,
    r: 0.451952,
    fill: "#9DED1A",
    fillOpacity: 0.85
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8175,
    cy: 50.8106,
    r: 0.796954,
    fill: "#480CA7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 173.483,
    cy: 53.9158,
    r: 0.451952,
    fill: "#03A3F5",
    fillOpacity: 0.65
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.023,
    cy: 42.8758,
    r: 0.451952,
    fill: "#C9FCBE",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.726 54.2132L139.789 55.1149L139.04 55.6204L138.227 55.2242L138.164 54.3224L138.914 53.817L139.726 54.2132Z",
    fill: "#FC9E1C",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9733 25.9959L56.8434 23.9905L58.8488 25.8605L56.9787 27.8659L54.9733 25.9959Z",
    fill: "#F54721",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6484 56.8738L15.8671 57.7509L15.2169 58.3788L14.348 58.1297L14.1293 57.2526L14.7795 56.6247L15.6484 56.8738Z",
    fill: "#BA3E03",
    fillOpacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.867 32.2569L105.227 32.8961L104.354 32.6621L104.12 31.789L104.76 31.1498L105.633 31.3838L105.867 32.2569Z",
    fill: "#DCBCFA",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.783 42.3197L163.859 44.4816L161.949 43.466L163.783 42.3197Z",
    fill: "#03A3F5",
    fillOpacity: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1842 30.4162L65.125 31.078L64.0223 30.4917L63.9787 29.2435L65.0379 28.5817L66.1406 29.168L66.1842 30.4162Z",
    fill: "#03A3F5",
    fillOpacity: 0.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7064 34.9657L27.2927 33.863L28.5409 33.8194L29.2027 34.8785L28.6164 35.9813L27.3682 36.0249L26.7064 34.9657Z",
    fill: "#C9FCBE",
    fillOpacity: 0.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.042 14.9003L116.477 14.8457L117.307 13.518L118.042 14.9003Z",
    fill: "#9AF5FC",
    fillOpacity: 0.65
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6574 38.2195L82.7964 36.6316L84.2409 35.958L85.5466 36.8723L85.4077 38.4601L83.9631 39.1337L82.6574 38.2195Z",
    fill: "#F54721",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.619 6.37496L106.2 3.33131L109.545 3.62401L107.619 6.37496Z",
    fill: "#FFED36",
    fillOpacity: 0.45
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4183 34.0119L51.5703 35.7916L51.4531 32.4353L54.4183 34.0119Z",
    fill: "#F54721",
    fillOpacity: 0.65
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0623 48.1467L89.8456 49.132L89.6007 47.5856L91.0623 48.1467Z",
    fill: "#480CA7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.708 3.15911L138.89 4.47167L137.577 5.6535L136.396 4.34094L137.708 3.15911Z",
    fill: "#FFED36",
    fillOpacity: 0.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.034 26.689L153.113 27.2203L152.324 26.5093L152.756 25.5386L153.813 25.6497L154.034 26.689Z",
    fill: "#DCBCFA",
    fillOpacity: 0.35
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.854 76.1922L108.621 74.5695L111.143 73.4466L110.854 76.1922Z",
    fill: "#4BC8EF",
    fillOpacity: 0.85
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.894 41.1646L149.787 41.0232L150.355 41.7256L150.032 42.5695L149.139 42.7109L148.57 42.0084L148.894 41.1646Z",
    fill: "#4BC8EF",
    fillOpacity: 0.9
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0181 3.64123L45.3481 3.06621L45.9231 1.39622L47.5931 1.97124L47.0181 3.64123Z",
    fill: "#F62584",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7708 78.8439L77.1206 81.0338L74.9307 79.3836L76.5809 77.1937L78.7708 78.8439Z",
    fill: "#755FFE",
    fillOpacity: 0.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.355 34.6796L105.058 34.1107L105.902 34.4347L106.043 35.3274L105.34 35.8963L104.497 35.5723L104.355 34.6796Z",
    fill: "#9DED1A",
    fillOpacity: 0.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7995 37.4146L98.8511 35.5673L99.4251 38.2677L96.7995 37.4146Z",
    fill: "#FFED36",
    fillOpacity: 0.9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M112.822 74.1209L111.402 74.8446L110.065 73.9765L110.149 72.3847L111.569 71.6611L112.906 72.5292L112.822 74.1209Z",
    fill: "#FFED36",
    fillOpacity: 0.65
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6334 47.0801L57.6492 46.3112L57.823 45.0744L58.981 44.6066L59.9651 45.3755L59.7913 46.6122L58.6334 47.0801Z",
    fill: "#480CA7",
    fillOpacity: 0.65
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.989 64.365L156.385 65.4011L157.434 65.0386L156.735 65.8998L157.573 66.6264L156.477 66.4515L156.267 67.5407L155.871 66.5046L154.822 66.8671L155.522 66.0059L154.684 65.2792L155.779 65.4541L155.989 64.365Z",
    fill: "#9AF5FC",
    fillOpacity: 0.45
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8104 36.6966L65.4318 36.599L65.3543 35.9747L65.7496 36.4641L66.2515 36.0849L66.0253 36.6718L66.6047 36.9169L65.9833 37.0145L66.0607 37.6388L65.6654 37.1494L65.1635 37.5286L65.3897 36.9416L64.8104 36.6966Z",
    fill: "#FC9E1C",
    fillOpacity: 0.35
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0965 19.9344L43.5971 20.6458L44.2919 21.168L43.4261 21.0911L43.3213 21.9539L42.955 21.1658L42.1553 21.5064L42.6548 20.795L41.96 20.2728L42.8257 20.3497L42.9306 19.4869L43.2969 20.2751L44.0965 19.9344Z",
    fill: "#9DED1A",
    fillOpacity: 0.85
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1371 46.4731L30.4489 47.5052L30.7844 48.6995L29.7523 48.0113L28.5581 48.3468L29.2462 47.3147L28.9107 46.1205L29.9428 46.8086L31.1371 46.4731Z",
    fill: "#C9FCBE",
    fillOpacity: 0.85
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3289 37.4745L70.3138 38.7149L71.2457 39.5338L70.0053 39.5188L69.1865 40.4506L69.2015 39.2102L68.2696 38.3914L69.51 38.4064L70.3289 37.4745Z",
    fill: "#F62584",
    fillOpacity: 0.35
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06792 82.3014L8.4376 81.6487L7.62205 82.0464L8.04804 81.2453L7.41772 80.5926L8.31132 80.7501L8.73731 79.9489L8.86359 80.8475L9.75719 81.0051L8.94164 81.4028L9.06792 82.3014Z",
    fill: "#9DED1A",
    fillOpacity: 0.85
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4358 49.5211L24.2048 50.4946L25.4443 50.5445L24.4708 51.3134L24.4209 52.5529L23.652 51.5795L22.4125 51.5296L23.3859 50.7606L23.4358 49.5211Z",
    fill: "#755FFE",
    fillOpacity: 0.9
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5035 75.336L93.939 74.5838L93.2014 74.1242L94.0705 74.1253L94.0998 73.2566L94.5334 74.0099L95.3003 73.6009L94.8648 74.353L95.6024 74.8127L94.7333 74.8116L94.7041 75.6802L94.2704 74.927L93.5035 75.336Z",
    fill: "#DCBCFA",
    fillOpacity: 0.35
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.827 7.3651L110.118 6.97221L109.767 5.66929L110.753 6.59077L111.706 5.63545L111.401 6.94982L112.705 7.29742L111.414 7.69031L111.765 8.99323L110.779 8.07174L109.826 9.02707L110.131 7.71269L108.827 7.3651Z",
    fill: "#9AF5FC",
    fillOpacity: 0.35
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2393 30.6963L96.6649 30.4398L96.3899 31.0055L96.3249 30.3798L95.6975 30.4245L96.2068 30.0554L95.8544 29.5343L96.4288 29.7909L96.7038 29.2251L96.7688 29.8508L97.3963 29.8062L96.8869 30.1753L97.2393 30.6963Z",
    fill: "#F54721",
    fillOpacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.791 37.251L139.803 38.17L140.69 39.1873L139.4 38.7911L138.962 40.0675L138.66 38.7524L137.336 39.0115L138.324 38.0925L137.438 37.0753L138.728 37.4714L139.165 36.195L139.467 37.5101L140.791 37.251Z",
    fill: "#C9FCBE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9028 84.6566L88.5331 85.3093L89.3487 84.9116L88.9227 85.7127L89.553 86.3655L88.6594 86.2079L88.2334 87.0091L88.1071 86.1105L87.2135 85.9529L88.0291 85.5552L87.9028 84.6566Z",
    fill: "#BA3E03",
    fillOpacity: 0.45
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7103 45.3358L88.8834 46.2265L89.7841 46.3371L88.9904 46.777L89.1636 47.6677L88.5 47.0489L87.7063 47.4888L88.0898 46.6664L87.4262 46.0476L88.3268 46.1582L88.7103 45.3358Z",
    fill: "#BA3E03",
    fillOpacity: 0.65
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54787 49.3149L2.74186 48.2228L1.65657 47.9935L2.69939 47.6155L2.35529 46.5609L3.20413 47.275L3.94532 46.4498L3.75133 47.5419L4.83662 47.7712L3.7938 48.1492L4.1379 49.2038L3.28907 48.4897L2.54787 49.3149Z",
    fill: "#FC9E1C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8166 23.8586L56.7213 23.6837L56.511 24.7729L56.1148 23.7368L55.0664 24.0992L55.7655 23.2381L54.9275 22.5114L56.0228 22.6863L56.2331 21.5972L56.6293 22.6332L57.6777 22.2708L56.9786 23.132L57.8166 23.8586Z",
    fill: "#03A3F5",
    fillOpacity: 0.65
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6936 23.7798L92.9199 23.9673L93.8604 23.1584L93.6729 24.3847L94.4818 25.3252L93.2555 25.1377L92.315 25.9466L92.5025 24.7203L91.6936 23.7798Z",
    fill: "#FC9E1C",
    fillOpacity: 0.65
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56776 19.4565L7.12861 19.1716L6.86204 18.6018L7.38918 18.9451L7.74934 18.4293L7.71563 19.0575L8.34236 19.1115L7.78151 19.3964L8.04807 19.9662L7.52094 19.6229L7.16078 20.1386L7.19449 19.5105L6.56776 19.4565Z",
    fill: "#C9FCBE",
    fillOpacity: 0.35
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8917 39.1517L36.1395 38.7162L35.6798 39.4539L35.6809 38.5847L34.8123 38.5555L35.5655 38.1219L35.1565 37.355L35.9087 37.7905L36.3683 37.0528L36.3672 37.922L37.2359 37.9512L36.4826 38.3848L36.8917 39.1517Z",
    fill: "#9DED1A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2779 15.6476L23.5143 15.0647L22.9393 14.8095L23.5624 14.7228L23.4958 14.0972L23.8825 14.5934L24.3909 14.223L24.1546 14.806L24.7296 15.0611L24.1065 15.1479L24.1731 15.7734L23.7864 15.2772L23.2779 15.6476Z",
    fill: "#03A3F5",
    fillOpacity: 0.65
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9874 21.0054L98.7016 19.9336L97.6211 20.1845L98.4065 19.4011L97.649 18.5908L98.72 18.8792L99.043 17.8181L99.3288 18.8899L100.409 18.639L99.6239 19.4223L100.381 20.2326L99.3104 19.9442L98.9874 21.0054Z",
    fill: "#F62584"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6176 83.3723L84.7541 82.7299L84.1854 82.4015L84.8385 82.3329L84.9751 81.6905L85.2422 82.2905L85.8953 82.2218L85.4073 82.6612L85.6744 83.2612L85.1056 82.9328L84.6176 83.3723Z",
    fill: "#480CA7",
    fillOpacity: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.917 28.3036L95.1329 27.0143L93.6438 26.7702L94.9331 25.9861L95.1771 24.497L95.9612 25.7863L97.4504 26.0303L96.161 26.8144L95.917 28.3036Z",
    fill: "#FFED36",
    fillOpacity: 0.75
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.238 67.3738L173.336 67.9953L173.96 67.9178L173.471 68.3131L173.85 68.815L173.263 68.5888L173.018 69.1682L172.92 68.5467L172.296 68.6242L172.785 68.2289L172.406 67.727L172.993 67.9532L173.238 67.3738Z",
    fill: "#F62584"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7324,
    cy: 41.9805,
    r: 27,
    fill: "#BE56F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_2629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7322 45.152L95.9242 35.959L97.3392 37.373L86.7322 47.98L80.3682 41.616L81.7822 40.202L86.7322 45.152Z",
    fill: "#F6F9F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_2629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(76.7324 29.9805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCheck);
export default __webpack_public_path__ + "static/media/star-check.b1e962b90cf2e9f0129d973850e0d5dc.svg";
export { ForwardRef as ReactComponent };